import { render, staticRenderFns } from "./UploadIndex.vue?vue&type=template&id=2fb4b658&scoped=true"
import script from "./UploadIndex.vue?vue&type=script&lang=js"
export * from "./UploadIndex.vue?vue&type=script&lang=js"
import style0 from "./UploadIndex.vue?vue&type=style&index=0&id=2fb4b658&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb4b658",
  null
  
)

export default component.exports